import { useEffect } from 'react';
import { createTheme } from '@mui/material/styles';
import { useLocalStorage } from './useLocalStorage';
import { STORAGE_KEYS } from '../utils/core/localStorageKeys';
import { paths } from '../utils/core/routes';
export enum ThemeType {
  LIGHT = 'light',
  DARK = 'dark',
}

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#E98300',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#696969',
      contrastText: '#ffffff',
    },
    info: {
      main: '#0288d1',
      contrastText: '#000',
    },
    success: {
      main: '#0ae600',
      contrastText: '#ffffff',
    },
    error: {
      main: '#ff0000',
      contrastText: '#ffffff',
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#E98300',
      contrastText: '#121212',
    },
    secondary: {
      main: '#696969',
      contrastText: '#fff',
    },
    info: {
      main: '#0288d1',
      contrastText: '#000',
    },
    success: {
      main: '#0ae600',
      contrastText: '#ffffff',
    },
    error: {
      main: '#ff0000',
      contrastText: '#ffffff',
    },
  },
});

export function useLocalTheme() {
  const [localTheme, setLocalTheme] = useLocalStorage(
    STORAGE_KEYS.THEME,
    location.search === '?dark=true' ? ThemeType.DARK : ThemeType.LIGHT,
  );

  useEffect(() => {
    if (location.search.includes('?dark=false') && localTheme === ThemeType.DARK) {
      setLocalTheme(ThemeType.LIGHT);
      window.location.search = `dark=false`;
    }
    if (location.search.includes('?dark=true') && localTheme === ThemeType.LIGHT) {
      setLocalTheme(ThemeType.DARK);
      window.location.search = `dark=true`;
    }
    if (
      location.pathname.includes('fullscreen/') &&
      !location.search.includes('?dark=true') &&
      !location.search.includes('?dark=false')
    ) {
      if (localTheme) {
        window.location.search = localTheme === ThemeType.LIGHT ? `dark=false` : `dark=true`;
      } else {
        setLocalTheme(ThemeType.LIGHT);
        window.location.search = `dark=false`;
      }
    }
  }, [location.search]);

  const changeLocalTheme = () => {
    let theme = localTheme;
    let urlQuery = location.search;
    if (localTheme === ThemeType.LIGHT) {
      theme = ThemeType.DARK;
      urlQuery = `dark=true`;
    }
    if (localTheme === ThemeType.DARK) {
      theme = ThemeType.LIGHT;
      urlQuery = `dark=false`;
    }
    setLocalTheme(theme);
    window.location.search = urlQuery;
  };

  return {
    changeLocalTheme,
    localTheme,
  };
}
